import React, { useState, useEffect, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router-dom";
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import {
  isAfter,
  parse,
  isValid,
  intervalToDuration,
  isBefore,
} from "date-fns";

import { Box, Flex } from "@chakra-ui/react";

import { CustomButton } from "../../../../components/CustomButton";
import { CriancaRegistrada } from "./CriancaRegistrada";
import { PossuiCartao } from "./PossuiCartao";
import { PossuiIdentidade } from "./PossuiIdentidade";
import { PossuiCPF } from "./PossuiCPF";
import { PossuiCTPS } from "./PossuiCTPS";
import { PossuiNumero } from "./PossuiNumero";

import DocumentacaoService from "../../../../../main/services/DocumentacaoService";
import CriancaService from "../../../../../main/services/CriancaService";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import {
  criancaFunc,
  vrCriancaFunc,
} from "../../../../../helpers/Funcionalidades";
import SemRegistros from "../../../../components/SemRegistros";
import { isValidCPF } from "../../../../utils/isValidCPF";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { scrollToFieldAnexo } from "../../../../utils/scrollToFIeldAnexo";

export const CadastrarDocumentacao = ({ dataNascimento }) => {
  const history = useHistory();
  const { id } = useParams();
  const { setCadastrarDocCrianca } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const { setCadastrarDocumentacao, idPJ } = useAppContext();
  const [dataFutura, setDataFutura] = useState(false);
  const [dataMenor, setDataMenor] = useState(false);
  const isNascidoAposMar2011 =
    dataNascimento >= new Date("2011-03-01").getTime();

  const [invalidCPF, setInvalidCPF] = useState(false);
  const [acolhedorValid, setAcolhedorValid] = useState(false);
  const [message, setMessage] = useState(false);

  const [initialValues] = useState({
    registrada: "",
    matricula: "",
    livro: "",
    folha: "",
    termo: "",
    certidao: null,
    possuiIdentidade: "",
    numeroIdentidade: "",
    orgaoExpedidor: "",
    dataExpedicaoIdentidade: "",
    identidade: null,
    possuiCpf: "",
    cpf: "",
    anexoCpf: null,
    possuiCtps: "",
    numeroCtps: "",
    serieCtps: "",
    dataExpedicaoCtps: "",
    ctps: null,
    possuiCartaoSus: "",
    numeroCartaoSus: "",
    possuiNumeroIdentidadeSocial: "",
    numeroIdentidadeSocial: "",
  });
  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  const [dataCrianca, setDataCrianca] = useState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idAnexo || idTipoPendencia, ref);
    },
    [idAnexo, idTipoPendencia]
  );

  useEffect(() => {
    CriancaService.getCrianca(id)
      .then((res) => {
        setDataCrianca(res.data);
      })
      .catch((err) => console.log("Erro no get de crianca"));

    DocumentacaoService.getDocumentacao(id)
      .then((res) => {
        Swal.fire({
          title: "Atenção!",
          text: "Já existe Documentação cadastrada para esta criança!",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push(`/crianca/visualizar-documentacao/${id}`);
        });
      })
      .catch((erro) => {});
  }, [history, id]);

  const schema = Yup.object().shape({
    registrada: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    matricula: Yup.string()
      .nullable()
      .when("registrada", {
        is: (registrada) => registrada === "S",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    livro: Yup.string()
      .nullable()
      .when("registrada", {
        is: (registrada) => registrada === "S" && !isNascidoAposMar2011,
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    folha: Yup.string()
      .nullable()
      .when("registrada", {
        is: (registrada) => registrada === "S" && !isNascidoAposMar2011,
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    termo: Yup.string()
      .nullable()
      .when("registrada", {
        is: (registrada) => registrada === "S" && !isNascidoAposMar2011,
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    certidao: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    possuiIdentidade: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    numeroIdentidade: Yup.string().when("possuiIdentidade", {
      is: (possuiIdentidade) => possuiIdentidade === "S",
      then: (schema) => schema.required("Este campo é obrigatório!"),
    }),
    orgaoExpedidor: Yup.string().nullable(),

    dataExpedicaoIdentidade: Yup.string()
      .nullable()
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      .test("dataExpedicaoAfterToday", "", (value) => {
        if (!value) {
          return true;
        } else {
          return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
        }
      })
      .test("dataExpedicaoNotAfterBirthday", "", (value) => {
        if (!value || !dataNascimento) {
          return true;
        }
        const dataExpedicaoTimestamp = parse(value, "dd/MM/yyyy", new Date());

        return !isAfter(dataNascimento, dataExpedicaoTimestamp);
      }),

    identidade: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    possuiCpf: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .when("possuiCtps", {
        is: (possuiCtps) => possuiCtps === "D",
        then: (schema) =>
          schema.test(
            "cpfRequired",
            "Cpf é obrigatório para CTPS digital!",
            (value) => {
              return value === "S";
            }
          ),
      }),
    cpf: Yup.string()
      .nullable()
      .when("possuiCpf", {
        is: (possuiCpf) => possuiCpf === "S",
        then: (schema) =>
          schema
            .required("Este campo é obrigatório!")
            .test("cpfValido", "", (value) => {
              if (!isValidCPF(value)) {
                return false;
              } else {
                return true;
              }
            })
            .test("unicidadeFamilia", "", (value) => {
              if (acolhedorValid) {
                return false;
              } else {
                return true;
              }
            }),
      }),

    anexoCpf: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    possuiCtps: Yup.string("Este campo é obrigatório!").test(
      "obrigatorio",
      "Este campo é obrigatório!",
      (value) => {
        const idade = intervalToDuration({
          start: new Date(dataCrianca.dataNascimento),
          end: new Date(),
        }).years;
        if (idade >= 16) {
          if (!!value) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    numeroCtps: Yup.string().when("possuiCtps", {
      is: (possuiCtps) => possuiCtps === "F",
      then: (schema) => schema.required("Este campo é obrigatório!"),
    }),
    serieCtps: Yup.string().when("possuiCtps", {
      is: (possuiCtps) => possuiCtps === "F",
      then: (schema) => schema.required("Este campo é obrigatório!"),
    }),
    dataExpedicaoCtps: Yup.string()
      .nullable()
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      .test(
        "dataExpedicaoAfterToday",
        "A data informada não pode ser uma data futura!",
        (value) => {
          if (!value) {
            return true;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        }
      )
      .when("possuiCtps", {
        is: (possuiCtps) => possuiCtps === "F",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    ctps: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    possuiCartaoSus: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    numeroCartaoSus: Yup.string().when("possuiCartaoSus", {
      is: (possuiCartaoSus) => possuiCartaoSus === "S",
      then: (schema) => schema.required("Este campo é obrigatório!"),
    }),
    possuiNumeroIdentidadeSocial: Yup.string(
      "Este campo é obrigatório!"
    ).required("Este campo é obrigatório!"),
    numeroIdentidadeSocial: Yup.string().when("possuiNumeroIdentidadeSocial", {
      is: (possuiNumeroIdentidadeSocial) =>
        possuiNumeroIdentidadeSocial === "S",
      then: (schema) => schema.required("Este campo é obrigatório!"),
    }),
  });

  const FocusErrorData = () => {
    const { values, setFieldError } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const { dataExpedicaoIdentidade, cpf } = values;
        const currentDate = new Date();

        if (dataExpedicaoIdentidade) {
          const movementDate = parse(
            dataExpedicaoIdentidade,
            "dd/MM/yyyy",
            new Date()
          );
          if (isAfter(movementDate, currentDate)) {
            setDataFutura(true);
            setDataMenor(false);
          } else {
            setDataFutura(false);
          }
        }

        if (dataNascimento && dataExpedicaoIdentidade) {
          const movementDate = parse(
            dataExpedicaoIdentidade,
            "dd/MM/yyyy",
            new Date()
          );

          if (
            isBefore(movementDate, dataNascimento) &&
            !isAfter(movementDate, currentDate)
          ) {
            setDataMenor(true);
          } else {
            setDataMenor(false);
          }
        }

        if (cpf) {
          if (isValidCPF(cpf)) {
            setInvalidCPF(true);
            setFieldError("cpf", "");
            DocumentacaoService.getDocumentacaoValidar(id, cpf)
              .then(() => setAcolhedorValid(false))
              .catch((error) => {
                setMessage(
                  error.response.data.message ? error.response.data.message : ""
                );
                setAcolhedorValid(true);
              });
          } else {
            setInvalidCPF(false);
            setFieldError("cpf", "");
          }
        }
      };

      validateDate();
    }, [values, values.dataMovimentacao, setFieldError]);

    return null;
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        dataExpedicaoIdentidade,
        dataExpedicaoCtps,
        certidao,
        identidade,
        anexoCpf,
        ctps,
        ...resto
      } = values;

      const valuesToSend = {
        dataExpedicaoIdentidade: dataExpedicaoIdentidade
          ? parse(
              dataExpedicaoIdentidade,
              "dd/MM/yyyy",
              new Date()
            ).toISOString()
          : "",
        dataExpedicaoCtps: dataExpedicaoCtps
          ? parse(dataExpedicaoCtps, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        ...resto,
      };

      if (certidao) {
        valuesToSend["certidao"] = certidao;
      }
      if (identidade) {
        valuesToSend["identidade"] = identidade;
      }
      if (anexoCpf) {
        valuesToSend["anexoCpf"] = anexoCpf;
      }
      if (ctps) {
        valuesToSend["ctps"] = ctps;
      }

      valuesToSend["possuiCpfAnexo"] = anexoCpf ? true : false;
      valuesToSend["possuiCertidaoAnexo"] = certidao ? true : false;
      valuesToSend["possuiCtpsAnexo"] = ctps ? true : false;
      valuesToSend["possuiIdentidadeAnexo"] = identidade ? true : false;

      DocumentacaoService.cadastrarDocumentacao(id, valuesToSend)
        .then((res) => {
          history.push("/crianca/visualizar-documentacao/" + id);
          setCadastrarDocumentacao(true);
          setCadastrarDocCrianca(false);
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "cpf") {
                  console.log(error);
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message
                      ? error.response.data.message
                      : "",
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  });
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    const tempKey = key.toString().split("[0]")[0];
                    actions.setFieldError(tempKey, errors[tempKey]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
        });

      actions.setSubmitting(false);
    }, 200);
  };

  return roleKeycloack &&
    (roleKeycloack?.includes(vrCriancaFunc.documentacaoCadastrar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    dataCrianca ? (
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(props) => (
          <Flex>
            {setCadastrarDocCrianca(
              hasFormChanged(initialValues, props.values)
            )}
            <FocusErrorData />
            <Form style={{ width: "100%" }}>
              <Box
                mt={"15px"}
                border={
                  ["9"].includes(idTipoPendencia) ? "3px solid #4299E199" : ""
                }
              >
                <CriancaRegistrada
                  isNascidoAposMar2011={isNascidoAposMar2011}
                  idAnexo={idAnexo}
                  scrollToField={scrollToField}
                />
                <PossuiIdentidade
                  props={props}
                  dataMenor={dataMenor}
                  dataFutura={dataFutura}
                  dataNascimento={dataNascimento}
                  idAnexo={idAnexo}
                  scrollToField={scrollToField}
                />
                <PossuiCPF
                  invalidCPF={invalidCPF}
                  acolhedorValid={acolhedorValid}
                  message={message}
                  idAnexo={idAnexo}
                  scrollToField={scrollToField}
                />
                {intervalToDuration({
                  start: new Date(dataCrianca.dataNascimento),
                  end: new Date(),
                })?.years >= 16 && (
                  <PossuiCTPS idAnexo={idAnexo} scrollToField={scrollToField} />
                )}
                <PossuiCartao />
                <PossuiNumero />
              </Box>
              <Flex mt="30px" justifyContent="flex-end">
                <CustomButton
                  type="submit"
                  translate="no"
                  isLoading={props.isSubmitting}
                  label="Salvar"
                />
              </Flex>
            </Form>
          </Flex>
        )}
      </Formik>
    ) : (
      <LoadingSpinner loading={true} />
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
